import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  getUserSettingsRequest,
  getUserSubscriptionMetadataRequest,
} from '../../../../../home/extra-actions';
import {
  resetPurchaseModifySubscriptionResponse,
  resetPurchaseSubscriptionRequestStatus,
  resetSchedulePlanUpgradeRequest,
  resetSubscription,
} from '../../billing-subscription-slice';
import {
  calculatePayRequest,
  dynamicCustomPlansRequest,
  getAccountSubscriptionRequest,
  modifySubscriptionRequest,
  paddlePollingThunk,
  purchaseModifySubscriptionRequest,
  purchaseSubscriptionRequest,
  schedulePlanUpgradeRequest,
} from '../../extra-actions';
import {
  CalculatePayRequest,
  PurchaseModifySubscriptionRequest,
  PurchaseSubscriptionRequest,
} from '../../types';
import { PaddleApplicationType } from '../../types/paddle';
import OutreachPlans from './outreach-plans';
import { DynamicCustomPlansRequest } from '../../types/purchase-lead-finder-credits';
import { updateIsPlanUpgradeScheduled, selectPaddleCustomerId } from '../../../../../home/home-slice';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetAccountSubscriptionRequestStatus:
    state.billingAndSubscription.getAccountSubscriptionRequest.status,
  sendDynamicCustomPlansRequestStatus:
    state.billingAndSubscription.getDynamicCustomPlansRequest.status,
  sendDynamicCustomPlansResponse:
    state.billingAndSubscription.getDynamicCustomPlansResponse,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  sendGetPlansResponse: state.billingAndSubscription.getPlansResponse,
  sendPurchaseSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseSubscriptionRequest.status,
  sendPurchaseSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseSubscriptionRequest.message,
  sendGetPurchaseModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseModifySubscriptionRequest.status,
  sendPurchaseModifySubscriptionResponse:
    state.billingAndSubscription.purchaseModifySubscriptionResponse,
  sendGetCalculatePayRequestStatus:
    state.billingAndSubscription.calculatePayRequest.status,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,

  getDynamicCustomPlansResponse:
    state.billingAndSubscription.getDynamicCustomPlansResponse,

  schedulePlanUpgradeRequestStatus:
    state.billingAndSubscription.schedulePlanUpgradeRequest.status,
  schedulePlanUpgradeRequestError:
    state.billingAndSubscription.schedulePlanUpgradeRequest.error,
  paymentProvider: state.home?.paymentProvider,
  userId: state.home?.userId,
  shAccountId: state.home?.shAccountId,
  userEmail: state.home?.email,
  adminSettings: state.adminSettings.adminSettings,
  paddlePolling: state.billingAndSubscription.paddlePolling,
  paddleCustomerId: selectPaddleCustomerId(state),
});

const mapDispatchToProps = {
  sendGetCalculatePayRequest: (payload: CalculatePayRequest) =>
    calculatePayRequest(payload),
  sendPurchaseSubscriptionRequest: (payload: PurchaseSubscriptionRequest) =>
    purchaseSubscriptionRequest(payload),
  sendPurchaseModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseModifySubscriptionRequest(payload),
  sendGetAccountSubscriptionRequest: () => getAccountSubscriptionRequest(),
  sendGetUserSettingsRequest: () => getUserSettingsRequest(),
  sendGetUserSubscriptionMetadataRequest: () =>
    getUserSubscriptionMetadataRequest(),
  resetSubscription: () => resetSubscription(),
  sendDynamicCustomPlansRequest: (payload: DynamicCustomPlansRequest) =>
    dynamicCustomPlansRequest(payload),

  sendSchedulePlanUpgradeRequest: () => schedulePlanUpgradeRequest(),
  resetSchedulePlanUpgradeRequest: () => resetSchedulePlanUpgradeRequest(),
  updateIsPlanUpgradeScheduled: () => updateIsPlanUpgradeScheduled(),
  startPaddlePollingThunk: (payload: {
    shAccountId: number;
    applicationType: PaddleApplicationType;
    planId?: number;
  }) => paddlePollingThunk(payload),

  resetPurchaseModifySubscriptionResponse: () => resetPurchaseModifySubscriptionResponse(),
  resetPurchaseSubscriptionRequestStatus: () => resetPurchaseSubscriptionRequestStatus(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(OutreachPlans);
